import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Normalises any image/file path so it always resolves to the backend origin.
//  - Absolute http(s) URLs: returned unchanged
//  - /api/files/...        -> ${BACKEND_URL}/api/files/...
//  - /api/uploads/...      -> ${BACKEND_URL}/api/uploads/...
//  - /uploads/...          -> ${BACKEND_URL}/api/uploads/...   (legacy paths)
//  - Empty/null            -> ""
export function resolveImage(url) {
  if (!url) return "";
  if (/^https?:\/\//i.test(url) || /^data:/i.test(url)) return url;
  if (url.startsWith("/uploads/")) return `${BACKEND_URL}/api${url}`;
  if (url.startsWith("/api/")) return `${BACKEND_URL}${url}`;
  return url;
}

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach Bearer token from localStorage for cross-origin reliability
api.interceptors.request.use((config) => {
  const t = localStorage.getItem("rg_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export default api;

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
